import React, { useEffect, useState } from 'react';
import ModalBody, { ModalProps } from './ModalBody';
import CustomTextInput from '../CustomTextInput';
import { useTranslation } from 'react-i18next';

interface DeleteModalProps extends ModalProps {
    deleteAction: () => void;
    title: string;
    itemName?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ deleteAction, open, handleClose, title, itemName }) => {
    const { t } = useTranslation();
    const [verificationText, setVerificationText] = useState('');

    return (
        <ModalBody
            closeText={t('cancel')}
            title={title}
            subTitle={t('delete')}
            description={itemName}
            okText={t('valider')}
            isOkVisible={false}
            thirdButton
            thirdText={t('delete')}
            open={open}
            handleClose={handleClose}
            handleThird={deleteAction}
            disabledThird={verificationText !== t('delete')}
        >
            <div className="w-300px pad-l-5px pad-r-5px pad-b-5px">{t('verificationDeleteText', { word: t('delete') })}</div>
            <CustomTextInput value={verificationText} onChange={(text) => setVerificationText(text)} />
        </ModalBody>
    );
};

export default DeleteModal;
